import AssignPercentagesError from './AssignPercentagesError';
class DuplicateBeneficiaryId extends AssignPercentagesError {
    constructor(options) {
        super('The request contains a duplicate beneficiary ID', options);
    }
}
export default DuplicateBeneficiaryId;
